/**
 * GuestLayout - Layout для гостевых страниц
 */

import React, { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext/AuthProvider";
import GuestMenu from "../menus/GuestMenu";

const GuestLayout = ({
    children,
    hero,
    showHeader = true,
    showFooter = true,
    landing = false,
}) => {
    const { isAuthenticated } = useAuthContext();
    const navigate = useNavigate();
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    const handleLoginClick = () => {
        navigate("/login");
    };

    const header = showHeader && (
        <header className="header">
            <div>
                <button
                    className="burger-button"
                    onClick={() => openBurgerFn && openBurgerFn()}
                    aria-label="Меню"
                >
                    <div></div>
                </button>
                <GuestMenu onTrigger={handleSetOpenBurger} />
            </div>

            <div className="header-right">
                {isAuthenticated ? (
                    <button className="user-cabinet-button">
                        <Link to="/ucp">Личный кабинет</Link>
                    </button>
                ) : (
                    <button
                        className="user-cabinet-button"
                        onClick={handleLoginClick}
                    >
                        Личный кабинет
                    </button>
                )}
                <div className="logo-container">
                    <img src="/media/logo_medieval.png" alt="Logo" />
                </div>
            </div>
        </header>
    );

    const defaultFooter = showFooter && (
        <footer className="footer">
            <a href="/privacy_policy.pdf" target="_blank" rel="noreferrer">
                <p>Политика конфиденциальности</p>
            </a>
            <p>© 2026. Medieval Role Play. Все права защищены.</p>
            <p>Пользовательское соглашение</p>
        </footer>
    );

    if (landing) {
        return (
            <div className="app-container app-container--guest-landing">
                <div className="guest-landing">
                    <div className="main-container main-container--quest guest-hero-panel">
                        {header}
                        <main>{hero}</main>
                    </div>
                    <div className="guest-page__body">{children}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="app-container">
            <div className="main-container main-container--quest">
                {header}
                <main>{children}</main>
            </div>
            {defaultFooter}
        </div>
    );
};

export default GuestLayout;
